import { app } from 'app/app';
import { AppController } from 'app/controller';
import { BaseLayout } from 'layout/base/main';
import { PreviewHeader } from 'module/previewHeader/main';
import { PreviewIFrame } from 'module/previewIFrame/main';
import { hasConsentGrantedOrDenied, onConsentChange } from 'util/consent';

class DemoIndex extends AppController {
    ready() {
        if (hasConsentGrantedOrDenied()) {
            this.allowPointerEvents();
        }
        onConsentChange(() => {
            if (hasConsentGrantedOrDenied()) {
                this.allowPointerEvents();
            }
        });
    }

    domBindings() {
        return {
            previewIFrame: '.m-previewIFrame',
            previewHeader: '.m-previewHeader',
        };
    }

    subs() {
        this.layout = new BaseLayout(document.documentElement);
        this.previewHeader = new PreviewHeader(this.dom.previewHeader);
        this.previewIFrame = new PreviewIFrame(this.dom.previewIFrame);
    }

    subEvents() {
        this.previewHeader.events.on(
            'changeSize',
            (sizeRequest) => this.previewIFrame.updateSize(sizeRequest.arguments[0]),
        );

        this.previewHeader.events.on(
            'changeSrc',
            (srcRequest) => this.previewIFrame.updateSrc(srcRequest.arguments[0]),
        );
    }

    allowPointerEvents() {
        this.previewIFrame.allowPointerEvents();
    }
}

app.boot(DemoIndex);

if (module.hot) {
    module.hot.accept(module.children, () => {
         
        console.log('Rebooting controller due to HMR...');
        app.boot(DemoIndex);
    });

    module.hot.accept(() => {});
}
